import React, { useState } from "react";
import TimeSheetApprovalPage from "./TimeSheetApprovalPage";
import LeaveApprovalPage from "./LeaveApprovalPage";
import WfhApprovalPage from "./WfhApprovalPage";
import NonCheckinApprovalPage from "./NonCheckinApprovalPage";
import type { TabType } from "../components/CheckInCheckOut/CheckInMain";

type User = {
    id: string;
    firstName: string;
    lastName: string;
    role: string;
    email?: string;
    permissions?: "Admin" | "Editor" | "Viewer";
};

interface ApprovalsPageProps {
    organizationId: string;
    currentUserId: string;
    users: User[];
    setActiveTab: React.Dispatch<React.SetStateAction<TabType>>;
    bg: string;
    color: string;
}

const ApprovalsPage: React.FC<ApprovalsPageProps> = ({
    organizationId,
    currentUserId,
    users,
    setActiveTab,
    bg,
    color,
}) => {
    const [activeSubTab, setActiveSubTab] = useState<"timesheets" | "leaves" | "wfh" | "noncheckin">("timesheets");

    return (
        <div className="w-full h-full flex flex-col min-h-0">
            {activeSubTab === "timesheets" ? (
                <TimeSheetApprovalPage
                    bg={bg}
                    color={color}
                    organizationId={organizationId}
                    currentUserId={currentUserId}
                    users={users}
                    setActiveTab={setActiveTab}
                    activeSubTab={activeSubTab}
                    setActiveSubTab={setActiveSubTab}
                />
            ) : activeSubTab === "leaves" ? (
                <LeaveApprovalPage
                    organizationId={organizationId}
                    currentUserId={currentUserId}
                    users={users}
                    setActiveTab={setActiveTab}
                    activeSubTab={activeSubTab}
                    setActiveSubTab={setActiveSubTab}
                />
            ) : activeSubTab === "wfh" ? (
                <WfhApprovalPage
                    organizationId={organizationId}
                    currentUserId={currentUserId}
                    users={users}
                    setActiveTab={setActiveTab}
                    activeSubTab={activeSubTab}
                    setActiveSubTab={setActiveSubTab}
                />
            ) : (
                <NonCheckinApprovalPage
                    organizationId={organizationId}
                    currentUserId={currentUserId}
                    users={users}
                    setActiveTab={setActiveTab}
                    activeSubTab={activeSubTab}
                    setActiveSubTab={setActiveSubTab}
                />
            )}
        </div>
    );
};

export default ApprovalsPage;
